"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSubscriptionSchema = exports.bulkAssetSchema = exports.createAssetSchema = exports.createProjectSchema = exports.createOrganizationSchema = exports.loginSchema = exports.registerSchema = void 0;
const zod_1 = require("zod");
const types_1 = require("./types");
const subscription_1 = require("./types/subscription");
// Auth schemas
exports.registerSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    password: zod_1.z.string().min(8),
    name: zod_1.z.string().min(2),
    companyName: zod_1.z.string().optional(),
    companyCountry: zod_1.z.string().optional(),
    companySector: zod_1.z.string().optional(),
    selectedPlan: zod_1.z.nativeEnum(subscription_1.SubscriptionPlan).optional(),
});
exports.loginSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    password: zod_1.z.string(),
});
// Organization schemas
exports.createOrganizationSchema = zod_1.z.object({
    name: zod_1.z.string().min(2),
    sector: zod_1.z.string().min(2),
    country: zod_1.z.string().length(2), // ISO country code
    // Contact information (optional)
    contactEmail: zod_1.z.string().email().optional().or(zod_1.z.literal('').transform(() => undefined)),
    contactPhone: zod_1.z.string().optional().or(zod_1.z.literal('').transform(() => undefined)),
    address: zod_1.z.string().optional().or(zod_1.z.literal('').transform(() => undefined)),
    city: zod_1.z.string().optional().or(zod_1.z.literal('').transform(() => undefined)),
    postalCode: zod_1.z.string().optional().or(zod_1.z.literal('').transform(() => undefined)),
    websiteUrl: zod_1.z.string().url().optional().or(zod_1.z.literal('').transform(() => undefined)),
    // Legal information (optional)
    registrationNo: zod_1.z.string().optional().or(zod_1.z.literal('').transform(() => undefined)),
    vatNumber: zod_1.z.string().optional().or(zod_1.z.literal('').transform(() => undefined)),
    // DPO information (optional)
    dpoName: zod_1.z.string().optional().or(zod_1.z.literal('').transform(() => undefined)),
    dpoEmail: zod_1.z.string().email().optional().or(zod_1.z.literal('').transform(() => undefined)),
});
// Project schemas
exports.createProjectSchema = zod_1.z.object({
    organizationId: zod_1.z.string().uuid(),
    name: zod_1.z.string().min(2),
    description: zod_1.z.string().optional(),
    framework: zod_1.z.nativeEnum(types_1.ComplianceFramework).default(types_1.ComplianceFramework.GDPR),
});
// Asset schemas
exports.createAssetSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    name: zod_1.z.string().min(2),
    type: zod_1.z.nativeEnum(types_1.AssetType),
    provider: zod_1.z.string().min(2),
    jurisdiction: zod_1.z.nativeEnum(types_1.Jurisdiction),
    criticality: zod_1.z.nativeEnum(types_1.Criticality),
});
exports.bulkAssetSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    assets: zod_1.z.array(zod_1.z.object({
        name: zod_1.z.string().min(2),
        type: zod_1.z.nativeEnum(types_1.AssetType),
        provider: zod_1.z.string().min(2),
        jurisdiction: zod_1.z.nativeEnum(types_1.Jurisdiction),
        criticality: zod_1.z.nativeEnum(types_1.Criticality),
    })),
});
exports.updateSubscriptionSchema = zod_1.z.object({
    plan: zod_1.z.nativeEnum(subscription_1.SubscriptionPlan),
});
